export default "__VITE_ASSET__03ea4514__"